__webpack_require__.S = {};
const initPromises = {};
const initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	let initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	const scope = __webpack_require__.S[name];
	const warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	const uniqueName = "frontend";
	const register = (name, version, factory, eager) => {
		const versions = scope[name] ||= {};
		const activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	const initExternal = (id) => {
		const handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			const module = __webpack_require__(id);
			if(!module) return;
			const initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			const initResult = initFn(module);
			if(initResult?.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	const promises = [];
	switch(name) {
		case "default": {
			register("@headlessui/react", "2.2.10", () => (Promise.all([__webpack_require__.e(955), __webpack_require__.e(318), __webpack_require__.e(676)]).then(() => (() => (__webpack_require__(1955))))));
			register("@reduxjs/toolkit", "2.12.0", () => (Promise.all([__webpack_require__.e(881), __webpack_require__.e(673)]).then(() => (() => (__webpack_require__(673))))));
			register("@tbg/collaterate-session-permissions-react", "1.1.0", () => (Promise.all([__webpack_require__.e(318), __webpack_require__.e(636)]).then(() => (() => (__webpack_require__(636))))));
			register("export-to-csv", "1.5.0", () => (__webpack_require__.e(926).then(() => (() => (__webpack_require__(8926))))));
			register("formik", "2.4.9", () => (Promise.all([__webpack_require__.e(627), __webpack_require__.e(318)]).then(() => (() => (__webpack_require__(7627))))));
			register("jwt-decode", "4.0.0", () => (__webpack_require__.e(420).then(() => (() => (__webpack_require__(4420))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(950), __webpack_require__.e(318)]).then(() => (() => (__webpack_require__(7950))))));
			register("react-redux", "9.3.0", () => (Promise.all([__webpack_require__.e(3), __webpack_require__.e(318)]).then(() => (() => (__webpack_require__(3003))))));
			register("react-router-dom", "7.18.2", () => (Promise.all([__webpack_require__.e(513), __webpack_require__.e(318), __webpack_require__.e(676)]).then(() => (() => (__webpack_require__(1513))))));
			register("react", "18.3.1", () => (__webpack_require__.e(43).then(() => (() => (__webpack_require__(5043))))));
			register("yup", "1.7.1", () => (__webpack_require__.e(44).then(() => (() => (__webpack_require__(6044))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};